module.exports = __webpack_public_path__ + "img/password.64e7c3c4.svg";